import { render, staticRenderFns } from "./channel-highlights.vue?vue&type=template&id=58e99646&scoped=true&"
import script from "./channel-highlights.vue?vue&type=script&lang=js&"
export * from "./channel-highlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e99646",
  null
  
)

export default component.exports